import React from 'react';
import HeroSection2 from '../sectionBlocks/HeroSection2';
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
import NewsLetter from '../sectionBlocks/NewsLetter';
import Footer from '../sectionBlocks/Footer';

const AllNFTs = ({loading, error, data, localData}) => {
  return (
    <>
      <HeroSection2 categoryName={"All NFTs"}/>
      <NFTMarketPlace 
        displayCollectionName = {`dn`} 
        collectionName = {``} 
        displayPagination = {``} 
        displayLink = {`dn`} 
        linkAddress = {``} 
        linkTitle = {``} 
        fetchingCardsRule = {({meta}) => meta.content[1]} 
        sliceStart = {0} 
        loading = {loading} 
        error = {error} 
        data = {data} 
        localData = {localData}
      />
      <NewsLetter/>
      <Footer/>
    </>
  );
};

export default AllNFTs;